import { updatePageProps } from '@eventbrite/datalayer-library';
import {
    hasUrgencySignalsEnabled,
    UrgencySignalsProps,
} from '@eventbrite/urgency-signals';
import { Event, EventDetailsProps, EventHeroScopedProps } from '../types';

export const dataLayerMiddleware = (
    event?: Event,
    components?: {
        eventDetails?: EventDetailsProps;
        eventHero?: EventHeroScopedProps;
    },
    urgencySignals?: UrgencySignalsProps,
) => {
    const eventDetails = components?.eventDetails;
    const eventHero = components?.eventHero;
    const page = {
        eventId: event?.id,
        isPaid: eventDetails?.refund?.isPaidEvent,
        isFree: !eventDetails?.refund.isPaidEvent,
        isOnline: event?.isOnlineEvent,
        isPrivate: event?.isProtected,
        isListed: event?.isListed,
        isLive: event?.isLive,
        isRepeatingEvent: event?.isSeriesParent && !!event?.childEvents,
        isSeriesParent: event?.isSeriesParent,
        eventStatus: event?.salesStatus.sales_status,
        hasUrgencySignals: hasUrgencySignalsEnabled(urgencySignals),
        hasEarlyBirdUrgencySignal: urgencySignals?.categories.earlyBird,
        hasNewUrgencySignal: urgencySignals?.categories.new,
        hasPopularUrgencySignal: urgencySignals?.categories.popular,
        hasFewTicketsLeftUrgencySignal: urgencySignals?.messages.fewTickets,
        hasSalesEndSoonUrgencySignal: urgencySignals?.messages.salesEndSoon,
        eventStartDate: event?.start.utc,
        eventEndDate: event?.end.utc,
        hasImages: eventHero?.items?.length,
    };

    updatePageProps({ page });
};
